<template>
  <div id="app" class="app">
    <Three></Three>
  </div>
</template>

<script>
import { TweenMax } from "gsap";
import Three from "@/components/Three.vue";
export default {
  name: "App",
  metaInfo: {
    title: "汽车维修手册与培训系统开发 | 福卡迪汽车技术",
    meta: [
      {
        name: "description",
        content:
          "提供汽车使用手册、维修手册、电路图册、诊断手册、备件目录、工时手册、3D仿真培训、多媒体教学视频等专业服务。支持英语、法语、西班牙语等多语种互译。",
      },
      {
        name: "keywords",
        content:
          "汽车使用手册,维修手册,电路图册,诊断手册,工时手册,备件目录,汽车维修视频,CG动画,3D培训系统,VR仿真维修,AR教学,汽车专用工具,售后服务平台,技术资料翻译",
      },
    ],
  },
  data() {
    return {
      data_yo: true,
    };
  },
  components: {
    Three,
    // Three2
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
  methods: {
    gundong() {
      let tween1 = TweenMax.to(".box2 .img1", 1, {
        x: 650,
        y: 550,
        ease: "Sine .easeInOut",
      });
      let tween2 = TweenMax.to(".box2 .img2", 1, {
        x: -600,
        y: -460,
        ease: "Sine.easeInOut",
      });
      if (this.data_yo) {
        tween1.play();
        tween2.play();
      }
      // 滚动动画的函数
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  width: 100%;
  height: 100%;
  background: rgb(0, 140, 255);
}
.box {
  padding: 0.25rem;
  background: lightgreen;
  width: 3rem;
  height: 3rem;
  margin-right: 0.25rem;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 480px;
}

.jl {
  width: 50px;
  height: 50px;
  background-repeat: no-repeat;
  background-size: 100%;
}

.box2 {
  position: relative;
  width: 800px;
  height: 600px;
  border: 2px solid pink;
  margin: 10px auto;
  overflow: hidden;
  .img1 {
    position: absolute;
    top: -400px;
    left: -600px;
    width: 600px;
    height: 400px;
    background-image: url("../assets/img/使用手册1.png");
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
  .img2 {
    position: absolute;
    top: 600px;
    left: 800px;
    width: 600px;
    height: 400px;
    background-image: url("../assets/img/使用手册2.png");
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.box3 {
  position: relative;
  width: 800px;
  height: 600px;
  border: 2px solid pink;
  margin: 10px auto;
  overflow: hidden;
  transform-style: preserve-3d;
  perspective: 1000;
  -webkit-perspective: 1000;
  .box3-bc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../assets/img/1\(1\).png");
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 999;
  }
  .box3-main {
    width: 1000px;
    height: 800px;
    transform: rotateX(56deg);
    margin-top: -180px;
    margin-left: -40px;
    .box3-main1 {
      width: 100%;
      height: 100%;
      transform: rotate(-47deg);

      .box3-li {
        padding: 20px;
        width: 100%;
        height: 25%;
        // background: pink;
        display: flex;
        justify-content: space-between;

        .box3-img {
          width: 23%;
          background-color: rgba(243, 131, 131, 0.632);
          box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1);
          transition: 0.5s;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
